import { defineMessages } from 'react-intl'

export const MARKETS = defineMessages({
  seller: {
    id: 'Markets.seller',
    defaultMessage: 'Seller‘s market'
  },
  buyer: {
    id: 'Markets.buyer',
    defaultMessage: 'Buyer‘s market'
  }
})

export const AIRDNA_QUALITY = defineMessages({
  basic: {
    id: 'AirDna.rentalQuality.basic',
    defaultMessage: 'basic'
  },
  nice: {
    id: 'AirDna.rentalQuality.nice',
    defaultMessage: 'nice'
  },
  fancy: {
    id: 'AirDna.rentalQuality.fancy',
    defaultMessage: 'fancy'
  }
})

export const AIRDNA_FREQUENCY = defineMessages({
  seldom: {
    id: 'AirDna.rentalFrequency.seldom',
    defaultMessage: 'seldom'
  },
  often: {
    id: 'AirDna.rentalFrequency.often',
    defaultMessage: 'often'
  }
})

export const AIRDNA_TOOLIPS = defineMessages({
  description: {
    id: 'AirDna.chartTooltipHeader.monthlyAverage',
    defaultMessage: '{month} Avg.'
  },
  revenue: {
    id: 'AirDna.chartTooltip.revenue',
    defaultMessage: '${amount}' // eslint-disable-line
  },
  occupancy: {
    id: 'AirDna.chartTooltip.occupancy',
    defaultMessage: '{amount} Nights'
  },
  adr: {
    id: 'AirDna.chartTooltip.nightlyRate',
    defaultMessage: '${amount}/night' // eslint-disable-line
  }
})

export const FORM_PLACEHOLDERS = defineMessages({
  firstName: {
    id: 'Form.placeholder.firstName',
    defaultMessage: 'First Name'
  },
  lastName: {
    id: 'Form.placeholder.lastName',
    defaultMessage: 'Last Name'
  },
  phone: {
    id: 'Form.placeholder.phone',
    defaultMessage: 'Phone'
  },
  email: {
    id: 'Form.placeholder.email',
    defaultMessage: 'Email Address'
  },
  address: {
    id: 'Form.placeholder.address',
    defaultMessage: 'Address'
  },
  zip: {
    id: 'Form.placeholder.zipCode',
    defaultMessage: 'Zip code'
  }
})

export const BUTTONS = defineMessages({
  back: {
    id: 'Buttons.navigation.back',
    defaultMessage: 'Back'
  },
  change: {
    id: 'Buttons.actions.change',
    defaultMessage: 'Change'
  }
})

export const QUESTIONS = defineMessages({
  prequalTopic: {
    id: 'Questions.prequal.topic',
    defaultMessage: 'Pre-Qual Request'
  },
  getPrequal: {
    id: 'Affordability.noPrequal.question',
    defaultMessage: 'Can I get a Pre-Qual?'
  },
  renewPrequal: {
    id: 'Affordability.hasPrequal.question',
    defaultMessage: 'Can you renew my Pre-Qual?'
  },
  timelineShrink: {
    id: 'Questions.timeline.shrink',
    defaultMessage: 'How do I shrink these timelines?'
  },
  affordabilityTopic: {
    id: 'Questions.affordability.topic',
    defaultMessage: 'Interest Rates & Affordability',
    description: 'Topic in email to REA'
  },
  lockInRates: {
    id: 'Questions.affordability.lockInRates',
    defaultMessage: 'How do I lock in before rates rise?'
  },
  downPayment: {
    id: 'Questions.affordability.downPayment',
    defaultMessage: 'What down payment do I really need?'
  },
  marketActivityTopic: {
    id: 'Questions.marketActivity.topic',
    defaultMessage: 'Markets & Buying Timelines',
    description: 'Topic in email to REA'
  },
  getStarted: {
    id: 'Questions.marketActivity.getStarted',
    defaultMessage: 'How do I get started?'
  },
  closeFaster: {
    id: 'Questions.marketActivity.closeFaster',
    defaultMessage: 'How can I close faster?'
  },
  airdnaTopic: {
    id: 'Questions.airdna.topic',
    defaultMessage: 'Short Term Rentals'
  },
  startToRent: {
    id: 'Questions.airdna.startToRent',
    defaultMessage: 'Can you help me get started?'
  },
  optimizeRent: {
    id: 'Questions.airdna.optimizeRent',
    defaultMessage: 'How else can short term rental income help me?'
  },
  zipCodeDetailTopic: {
    id: 'Questions.zipCodeDetail.topic',
    defaultMessage: 'What should I know about {zipcode}?'
  },
  listings: {
    id: 'Questions.listings',
    defaultMessage: 'How can I see homes in {zipcode}?'
  },
  listingsTopic: {
    id: 'Questions.listingsTopic',
    defaultMessage: 'Listings'
  },
  placeholder: {
    id: 'Questions.placeholder',
    defaultMessage: 'Ask a question…'
  },
  sendSuccess: {
    id: 'Questions.send.success',
    defaultMessage: 'Message sent!'
  },
  sendFailure: {
    id: 'Questions.send.failure',
    defaultMessage: 'Message failed to send'
  },
  favoriteMarketsTitle: {
    id: 'Questions.favoriteMarkets.title',
    defaultMessage: 'Have any questions?'
  },
  favoriteMarketsTopic: {
    id: 'Questions.favoriteMarkets.topic',
    defaultMessage: 'Exploring Markets'
  },
  whatMarkets: {
    id: 'Questions.favoriteMarkets.whatMarkets',
    defaultMessage: 'What areas should I be looking at?'
  },
  fasterHomeSearch: {
    id: 'Questions.favoriteMarkets.fasterHomeSearch',
    defaultMessage: 'Is there new construction I should know about?'
  },
  homebuyingTopic: {
    id: 'Questions.homebuying.topic',
    defaultMessage: 'Homebuying'
  },
  homebuyingPlaceholder: {
    id: 'Questions.homebuying.placeholder',
    defaultMessage: 'Questions?'
  },
  mortgageInsuranceTopic: {
    id: 'Questions.mortgageInsurance.topic',
    defaultMessage: 'Mortgage Insurance'
  },
  mortgageInsuranceFooter: {
    id: 'Questions.mortgageInsurance.dropPMIFaster',
    defaultMessage: 'How would I drop mortgage insurance faster?'
  },
  reverseMortgagesTitle: {
    id: 'Questions.reverseMortgages.title',
    defaultMessage: 'Want to learn more?'
  },
  reverseMortgagesTopic: {
    id: 'Questions.reverseMortgages.topic',
    defaultMessage: 'Reverse Mortgages'
  },
  eligibleHomeTypes: {
    id: 'Questions.reverseMortgages.eligibleHomeTypes',
    defaultMessage: 'What types of homes are eligible?'
  },
  estateLeavable: {
    id: 'Questions.reverseMortgages.estateLeavable',
    defaultMessage: 'Will we have an estate that we can leave to our heirs?'
  },
  interestCardTopic: {
    id: 'Questions.interest.topic',
    defaultMessage: 'Principal Payments'
  },
  interestCardRefinance: {
    id: 'Questions.interest.vsRefinance',
    defaultMessage: 'What are the trade-offs versus refinancing?'
  },
  interestCardLargePayment: {
    id: 'Questions.interest.singleLargePayment',
    defaultMessage: 'What if I made a single large payment?'
  },
  refinanceTopic: {
    id: 'Questions.refinance.topic',
    defaultMessage: 'Refinancing'
  },
  refinanceRate: {
    id: 'Questions.refinance.rateQuestion',
    defaultMessage: 'What would my rate be?'
  },
  refinanceCost: {
    id: 'Questions.refinance.costQuestion',
    defaultMessage: 'How much does it cost?'
  },
  refinanceFees: {
    id: 'Questions.refinance.feeQuestion',
    defaultMessage: 'Can you explain the fees?'
  },
  refiDetailsSend: {
    id: 'Questions.refinance.refiDetailsSend',
    defaultMessage: 'Have {contactFirstName} run your {label}'
  },
  refiDetailsCheck: {
    id: 'Questions.refinance.refiDetailsCheck',
    defaultMessage: 'Check your {label} options'
  },
  insuranceTopic: {
    id: 'Questions.insurance.topic',
    defaultMessage: 'insurance agents'
  },
  insuranceRecommendation: {
    id: 'Questions.insurance.recommendation',
    defaultMessage: 'Do you know any insurance agents?'
  }
})

export const SHARE = defineMessages({
  success: {
    id: 'Homeowner.share.success',
    defaultMessage: 'Invite sent!'
  }
})

export const SUBSCRIPTIONS = defineMessages({
  notificationSubscribed: {
    id: 'Subscriptions.subscribed',
    defaultMessage: 'You have been subscribed to the monthly report'
  },
  notificationUnsubscribed: {
    id: 'Subscriptions.unsubscribed',
    defaultMessage: 'You have been unsubscribed from the monthly report'
  },
  notificationError: {
    id: 'Subscriptions.error',
    defaultMessage: 'There was an error changing your subscription status'
  }
})

export const ZIP_CODE_DETAIL = defineMessages({
  popularity: {
    id: 'ZipCodeDetail.sectionHeader.popularity',
    defaultMessage: 'Temperature'
  },
  houseSize: {
    id: 'ZipCodeDetail.sectionHeader.houseSize',
    defaultMessage: 'House size'
  },
  prices: {
    id: 'ZipCodeDetail.sectionHeader.prices',
    defaultMessage: 'Prices'
  },
  timeline: {
    id: 'ZipCodeDetail.sectionHeader.timeline',
    defaultMessage: 'Buying timeline'
  },
  timelineDuration: {
    id: 'Timeline.prepare.duration',
    defaultMessage: '{daycount} days'
  },
  sqft: {
    id: 'ZipCodeTable.activeFilter.sqft',
    defaultMessage: '{value, number} sqft'
  }
})

export const ZIP_CODE_EXPLORER = defineMessages({
  searchPlaceholder: {
    id: 'ZipCodeExplorer.search.placeholder',
    defaultMessage: 'Search for a city…'
  },
  filterPlaceholder: {
    id: 'ZipCodeExplorer.filter.placeholder',
    defaultMessage: 'Filter by neighborhood…'
  }
})

export const ERRORS = defineMessages({
  defaultHeadline: {
    id: 'ErrorBoundary.default.headline',
    defaultMessage: 'Something went wrong…'
  },
  defaultMessage: {
    id: 'ErrorBoundary.default.message',
    defaultMessage:
      'Our team has been notified. Try reloading the page in a few minutes.'
  }
})

export const PREFERENCES = defineMessages({
  saved: {
    id: 'Preferences.notifications.saved',
    defaultMessage: 'Your preferences were saved!'
  },
  errored: {
    id: 'Preferences.notifications.errored',
    defaultMessage:
      'Failed communication with our server, your preferences have not been persisted.'
  },
  duh: {
    id: 'Preferences.notifications.duh',
    defaultMessage:
      'Client preferences are not persisted when previewing a digest.'
  }
})

export const NO_ACCESS_ERROR = defineMessages({
  defaultMessage: {
    id: 'ErrorBoundary.noAccess.loanBalance.message',
    defaultMessage:
      'Sorry, you can’t update the loan balance on behalf of your client.'
  }
})

export const HOME_DETAIL_UPDATE_ERROR = defineMessages({
  defaultMessage: {
    id: 'ErrorBoundary.valuation.homeUpdate.failure.message',
    defaultMessage:
      'Your new value has been saved in our system, but we couldn’t reflect the updates in your digest. Please try refreshing.'
  }
})

export const STREAM_NOTIFICATIONS = defineMessages({
  unverified_loans: {
    id: 'StreamNotifications.unverified_loans',
    defaultMessage:
      "We found loan info in public records for your home, but it's missing the interest rate. Confirm the details to make Homebot more accurate."
  },
  no_loans: {
    id: 'StreamNotifications.no_loans',
    defaultMessage:
      'Do you have any loans? Homebot is more accurate when it knows your loans.'
  },
  refi_30: {
    id: 'StreamNotifications.refi_30',
    defaultMessage:
      'You may be able to do a 30-year refi with a lower rate, which could save a lot in the long run and lower your monthly payments.'
  },
  refi_15: {
    id: 'StreamNotifications.refi_15',
    defaultMessage:
      'Doing a 15-year refi could grow your wealth a lot faster. It may require a larger monthly payment, but you might be able to do it!'
  },
  reverse: {
    id: 'StreamNotifications.reverse',
    defaultMessage:
      'You may qualify for a Reverse Mortgage to eliminate your mortgage payment and maybe even generate monthly income back to you!'
  },
  pmi: {
    id: 'StreamNotifications.pmi',
    defaultMessage:
      'You are close to getting out of your mortgage insurance! This could be huge for you.'
  },
  pp_investment: {
    id: 'StreamNotifications.pp_investment',
    defaultMessage: 'You may have purchasing power for an investment property.'
  },
  pp_trade: {
    id: 'StreamNotifications.pp_trade',
    defaultMessage:
      'It looks like you may have enough purchasing power to consider trading up to a new home!'
  },
  rental: {
    id: 'StreamNotifications.rental',
    defaultMessage:
      'Have you noticed how much wealth you could build by renting your home on Airbnb or VRBO?'
  },
  principal_pay: {
    id: 'StreamNotifications.principal_pay',
    defaultMessage:
      'Pro tip: Even just a small additional monthly payment toward principal can often dramatically accelerate your wealth building.'
  },
  cash_out: {
    id: 'StreamNotifications.cash_out',
    defaultMessage:
      'You may have "cashout power" to do things like home improvement or high-interest debt consolidation.'
  }
})

export const REFINANCE = defineMessages({
  savings: {
    id: 'Refinance.savingsDescriptor',
    defaultMessage: 'savings'
  },
  loss: {
    id: 'Refinance.lossDescriptor',
    defaultMessage: 'loss'
  },
  paymentIncrease: {
    id: 'Refinance.paymentIncrease.descriptor',
    defaultMessage: 'up'
  },
  paymentDecrease: {
    id: 'Refinance.paymentDecrease.descriptor',
    defaultMessage: 'down'
  }
})

export const LOAN_BALANCE = defineMessages({
  balanceIncreasedSuccessMessage: {
    id: 'Loan.balance.success.messsage',
    defaultMessage: 'Your balance was successfully updated!'
  }
})

export const HOME_INSURANCE = defineMessages({
  feedbackReceived: {
    id: 'Homeowner.homeInsurance.feedbackReceived',
    defaultMessage: 'Thanks for the feedback!'
  }
})

export const PROMPT_PREQUAL = defineMessages({
  email_link: {
    id: 'PromptPrequal.done.emailName',
    defaultMessage: 'Email {name}'
  }
})

export const SYSTEM_REQUEST = defineMessages({
  mcSuccessTopic: {
    id: 'SystemRequest.mcSuccessTopic',
    defaultMessage: 'Mortgage Coach'
  },
  prequalTopic: {
    id: 'SystemRequest.prequalTopic',
    defaultMessage: 'Buyer Prequalification'
  },
  prequalMessage: {
    id: 'SystemRequest.prequalMessage',
    defaultMessage: 'Can you get me prequalified?'
  },
  refiTopic: {
    id: 'SystemRequest.refiTopic',
    defaultMessage: 'Refinancing'
  },
  refiMessage: {
    id: 'SystemRequest.refiMessage',
    defaultMessage: 'Please send my refi options'
  },
  labeledRefiMessage: {
    id: 'SystemRequest.labeledRefiMessage',
    defaultMessage: 'Please send me {label} refi options'
  },
  instantOfferTopic: {
    id: 'SystemRequest.instantOfferTopic',
    defaultMessage: 'instant offer'
  },
  instantOfferMessage: {
    id: 'SystemRequest.instantOfferMessage',
    defaultMessage: 'clicked through their digest to get an Instant Offer'
  }
})

export const MARKET_TEMP_DESCRIPTIONS = defineMessages({
  '0-20': {
    id: 'Explorer.marketTemp.0-20',
    defaultMessage:
      'A strong buyer’s advantage means there’s little competition and high inventory, which means you have great negotiating power.'
  },
  '21-40': {
    id: 'Explorer.marketTemp.21-40',
    defaultMessage:
      'A buyer’s advantage means there’s some competition but you’re still likely to get a good deal since inventory is high.'
  },
  '41-60': {
    id: 'Explorer.marketTemp.41-60',
    defaultMessage:
      'A balanced market means there’s good inventory and stable home values.'
  },
  '61-80': {
    id: 'Explorer.marketTemp.61-80',
    defaultMessage:
      'A seller’s advantage means there’s decent competition but home values are growing steadily, which could be a great investment.'
  },
  '81-100': {
    id: 'Explorer.marketTemp.81-100',
    defaultMessage:
      'A strong seller’s advantage means there’s fierce competition and low inventory.'
  }
})
